export default __webpack_public_path__ + "static/media/glitch001.6c735302.png";